import React from "react";
import IconButton from "./IconButton";
const help = require("../constants/help");

class HelpPanel extends React.Component {
  constructor(props) {
    super(props);
    this.state = { expanded: false, search: "", showTopShadow: false };

    this.refScrollList = React.createRef();
  }

  onSearch(e) {
    this.setState({ search: e.target.value });
  }

  onClose(e) {
    e.stopPropagation();
    this.setState({ search: "", expanded: false });
    this.props.onClose();
  }

  onScroll(e) {
    const { showTopShadow } = this.state;

    const newShowTopShadow = e.target.scrollTop > 16;

    if (showTopShadow !== newShowTopShadow)
      this.setState({ showTopShadow: newShowTopShadow });
  }

  render() {
    const { expanded, search, showTopShadow } = this.state;

    const helpItems = help.map((h, index, array) => {
      if (
        search.length <= 0 ||
        index + 1 === array.length ||
        h.title.toLowerCase().includes(search.toLowerCase()) ||
        h.content.toLowerCase().includes(search.toLowerCase())
      )
        return (
          <div id="HelpCard" key={h.title}>
            <h4>{h.title}</h4>
            <p>{h.content}</p>
          </div>
        );
    });

    const hideString = this.props.visible ? "" : " HelpPanel-Hidden";

    return (
      <div
        className={`HelpPanel${hideString}`}
        id={expanded ? "Expand" : ""}
        onClick={() => this.setState({ expanded: true })}
      >
        <div id="Head">
          Hilfe-Center
          <IconButton icon="times" onClick={e => this.onClose(e)} />
        </div>
        <div
          className="ProjectsDropdown-T2"
          style={
            showTopShadow
              ? {
                  borderColor: "var(--color-divider)",
                  borderBottomStyle: "solid"
                }
              : {}
          }
        >
          <i className="fas fa-search" />
          <input
            type="text"
            value={search}
            placeholder="Suchen"
            onChange={e => this.onSearch(e)}
          />
        </div>
        <div
          className="HelpPanelCardContainer"
          ref={this.refScrollList}
          onScroll={e => this.onScroll(e)}
        >
          <div className="HelpPanelCardWrap">{helpItems}</div>
        </div>
      </div>
    );
  }
}

export default HelpPanel;



// WEBPACK FOOTER //
// ./src/components/HelpPanel.js